import { render, staticRenderFns } from "./ListSaldo.vue?vue&type=template&id=df327c72"
import script from "./ListSaldo.vue?vue&type=script&lang=js"
export * from "./ListSaldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports